<template>
  <div
    class="dropdown-option flex cursor-pointer items-center gap-2.5 rounded-md px-2.5 py-2 text-neutral-800 transition-colors duration-100 hover:bg-primary-100"
    :data-test="data_test"
    :role="role"
    :aria-disabled="disabled ? 'true' : 'false'"
    :class="{ 'cursor-not-allowed! opacity-50': disabled }"
    v-bind="$attrs"
    v-tooltip.left="{ value: tooltip }"
    @click="onClick"
  >
    <slot />
  </div>
</template>

<script setup>
import { inject } from 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  data_test: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  role: { type: String, default: 'menuitem' },
  keep_open: { type: Boolean, default: false },
  tooltip: { type: String, default: null },
});

const dropdownHide = inject('dropdownHide', null);

const onClick = () => {
  if (props.disabled) return;
  emit('click');
  if (!props.keep_open && dropdownHide) {
    dropdownHide();
  }
};
</script>

<style scoped>
.dropdown-option :deep(svg) {
  color: var(--color-neutral-500);
  transition: color 0.1s ease;
}
.dropdown-option:hover :deep(svg) {
  color: var(--color-neutral-800);
}
</style>
